import { UserRole } from '@/app/shared/enums/UserRole';

const permissionsHierarchy = {
    guest_operations: {
        [UserRole.GUEST_OPERATIONS_ADMIN]: 1,
        [UserRole.GUEST_OPERATIONS_FPO]: 2,
        [UserRole.GUEST_OPERATIONS_SUPPORT_STAFF]: 3,
        [UserRole.GUEST_OPERATIONS_FULL_VIEW]: 4,
        [UserRole.GUEST_OPERATIONS_RESTRICTED_VIEW]: 5,
        [UserRole.GUEST_OPERATIONS_SEATING_VIEW_ONLY]: 6,
    },
};

const groupedPermissionsHierarchy = Object.entries(permissionsHierarchy).reduce(
    (acc, [type, permissions]) => {
        acc[type] = Object.entries(permissions).reduce(
            (permissionsMap, [userRole, hierarchy], index, array) => {
                permissionsMap[userRole] = array
                    .filter(([, otherHierarchy]) => otherHierarchy <= hierarchy)
                    .map(([otherRole]) => otherRole);
                return permissionsMap;
            },
            {}
        );

        return acc;
    },
    {}
);

export const hasUserGroup = (user, groupCode) => {
    return user.group.code === groupCode;
};

export const hasUserRole = (user, roles, combinator = 'or') => {
    const rolesList = Array.isArray(roles) ? roles : [roles];
    return combinator === 'or'
        ? rolesList.some((role) => user.roles.includes(role))
        : rolesList.every((role) => user.roles.includes(role));
};

export const hasAtLeastRole = (user, group, role) => {
    const rolesWithPermission = groupedPermissionsHierarchy[group]?.[role] ?? [];

    return (
        hasUserGroup(user, group) && rolesWithPermission.some((_role) => user.roles.includes(_role))
    );
};

export const isGroupAdmin = (user, group) => {
    return hasUserGroup(user, group) && hasUserRole(user, getGroupAdminRole(group));
};

export const hasMainEventRole = (user, mainEventPermissions, mainEventId, roles) => {
    const rolesList = Array.isArray(roles) ? roles : [roles];

    if (!mainEventPermissions[mainEventId]) {
        return false;
    }

    return rolesList.some((roleCode) => mainEventPermissions[mainEventId][roleCode]);
};

export const hasEventRole = (user, eventPermissions, eventId, roles) => {
    const rolesList = Array.isArray(roles) ? roles : [roles];

    if (!eventPermissions[eventId]) {
        return false;
    }

    return rolesList.some((roleCode) => eventPermissions[eventId][roleCode]);
};

const groupAdminRole = {
    guest_operations: UserRole.GUEST_OPERATIONS_ADMIN,
};

export const getGroupAdminRole = (group) => groupAdminRole[group];
